import { useDealerContext } from "@porsche-customer/slfinrtl-context"
import { useCallback } from "react"
import { getCurrencyLimit, MAX_NUMBER_OF_YEARS_TO_DROP, PERCENTAGE_DROP_BY_YEAR } from "./getCurrencyLimit"

interface UseCurrencyLimitReturn {
	isPriceBelowCurrencyLimit: (price: number, modelYear: number) => boolean
}

export const useCurrencyLimit = (): UseCurrencyLimitReturn => {
	const { currency } = useDealerContext()
	const min = getCurrencyLimit(currency)

	const isPriceBelowCurrencyLimit = useCallback(
		(price: number, modelYear: number): boolean => {
			return (
				min !== undefined &&
				price < subtractPercentage(min, PERCENTAGE_DROP_BY_YEAR, new Date().getFullYear() - modelYear)
			)
		},
		[min],
	)

	return { isPriceBelowCurrencyLimit }
}

const subtractPercentage = (value: number, percentage: number, times: number) => {
	return Math.max(0, value - value * (percentage / 100) * Math.min(MAX_NUMBER_OF_YEARS_TO_DROP, times))
}
